import { createRouter,createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import ProductCategory from '../views/master/ProductCategory.vue'
import StichingCategory from '../views/master/StichingCategory.vue'
import AddProduct from '../views/product/AddProduct.vue'
import ListProduct from '../views/product/ListProduct.vue'
import Barcode from '../views/product/Barcode.vue'
import Vendors from '../views/master/Vendors.vue'
import Customer from '../views/master/Customer.vue'
import SaleView from '../views/sale/SaleView.vue'
import SaleList from '../views/sale/SaleList.vue'
import print from '../views/sale/print.vue'
import thermalPrint from '../views/sale/thermalPrint.vue'
import PurchaseView from '../views/purchase/PurchaseView.vue'
import PurchaseList from '../views/purchase/PurchaseList.vue'
import delievryReport from '../views/report/delievryReport.vue'
import itemReport from '../views/report/itemReport.vue'
import accountReport from '../views/accounting/accountReport.vue'
import addplotView from '../views/plot/addplot.vue'
import EmployeeView from '../views/master/addemployee.vue'
import OpeningStockView from '../views/openingstock/OpeningStock.vue'
import purchasessView from '../views/openingstock/purchasess.vue'

import thermalPrintsView from '../views/purchase/thermalPrints.vue'
import EmployeesView from '../views/master/addemployees.vue'

import purchasereportView from '../views/report/purchasereport.vue'
import BranchView from '../views/branch/addbranch.vue'
import employeeattendanceView from '../views/attendance/employeeattendance.vue'
import attendanceReportView from '../views/report/attendancereport.vue'
import reportgadibhadeView from '../views/attendance/reportgadibhade.vue'
import consumptionView from '../views/report/consumption.vue'
import salaryslipReportView from '../views/report/salarySlipReport.vue'
import salaryslipDetailsView from '../views/report/salarySlipDetails.vue'
import filterattendanceReportView from '../views/report/filterattendancereport.vue'
import stocktransferView from '../views/stocktransfer/stocktransfer.vue'
import stocktransferlistView from '../views/stocktransfer/stocktransferlist.vue'
import stocktransferPrintsView from '../views/stocktransfer/stocktransferPrints.vue'
import consumptionPrintView from '../views/sale/consumptionPrint.vue'
import saleableproductView from '../views/master/saleableproduct.vue'
import partyView from '../views/master/party.vue'
import saleconsumptionView from '../views/salesconsumption/saleconsumption.vue'
import saleconsumptionlistView from '../views/salesconsumption/saleconsumptionlist.vue'
import saleconsumptionreportView from '../views/salesconsumption/saleconsumptionreport.vue'
import salelegerView from '../views/master/saleleger.vue'
import addexpensesView from '../views/expenses/addexpenses.vue'
import expensesreportView from '../views/expenses/expensesreport.vue'
import groupView from '../views/master/group.vue'
import materialView from '../views/master/material.vue'
import materialtranscationView from '../views/mattranscation/materialtranscation.vue'

import singleattendancereportView from '../views/attendance/singleattendancereport.vue'
import transcationlistView from '../views/TranscationList/transcationlist.vue'
import purchasetransactionView from '../views/TranscationList/purchasetransaction.vue'
import fuelstockView from '../views/master/fuelstock.vue'
import fuelpartyView from '../views/master/fuelparty.vue'
import fuelconsumptionView from '../views/fuel/fuelconsumption.vue'
import fueltypeView from '../views/master/fueltype.vue'
import fuelconsumptionreportView from '../views/report/fuelconsumptionreport.vue'
import fueltrnasferView from '../views/fuel/fueltransfer.vue'
import singlefuelreportView from '../views/fuel/singlefuelreport.vue'
import productFullReport from '../views/report/productFullReport.vue'
import AdvancedList from '../views/product/AdvancedList.vue'
import grapeslistView from '../views/salesconsumption/grapesView.vue'
import purchaselistView from '../views/purchase/purchaselistView.vue'



const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: HomeView
  },
  {
    path: '/AdvancedList',
    name: 'AdvancedList',
    component: AdvancedList
  },
  {
    path: '/Barcode',
    name: 'Barcode',
    component: Barcode
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/productFullReport',
    name: 'productFullReport',
    component: productFullReport
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/employee',
    name: 'employee',
    component: EmployeeView
  },
  {
    path: '/salaryslipreport',
    name: 'salaryslipreport',
    component: salaryslipReportView
  },
  {
    path: '/attendancereport',
    name: 'attendancereport',
    component: attendanceReportView
  },
  {
    path: '/filterattendancereport',
    name: 'filterattendancereport',
    component:  filterattendanceReportView
  },


  {
    path: '/branch',
    name: 'branch',
    component: BranchView
  },
  {
    path: '/employees',
    name: 'employees',
    component: EmployeesView
  },
  {
    path: '/employeeattendance',
    name: 'employeeattendance',
    component: employeeattendanceView
  },

  {
    path: '/stocktransfer',
    name: 'stocktransfer',
    component: stocktransferView
  },

  {
    path: '/stocktransferlist',
    name: 'stocktransferlist',
    component: stocktransferlistView
  },


  {
    path: '/thermalPrint',
    name: 'thermalPrint',
    component: thermalPrint
  },

  
  {
    path: '/reportgadibhade',
    name: 'reportgadibhade',
    component: reportgadibhadeView
  },


  {
    path: '/thermalPrints',
    name: 'thermalPrints',
    component: thermalPrintsView
  },


  {
    path: '/stocktransferPrints',
    name: 'stocktransferPrints',
    component: stocktransferPrintsView
  },

  {
    path: '/productcategory',
    name: 'productcategory',
    component: ProductCategory
  },

  {
    path: '/consumption',
    name: 'consumption',
    component: consumptionView 
  },


  {
    path: '/addplot',
    name: 'addplot',
    component: addplotView
  },

  {
    path: '/salaryslipdetails',
    name: 'salaryslipdetails',
    component: salaryslipDetailsView
  },


  {
    path: '/purchasereport',
    name: 'purchasereport',
    component: purchasereportView
  },


  {
    path: '/openingstock',
    name: 'openingstock',
    component: OpeningStockView
  },
  {
    path: '/stichingcategory',
    name: 'stichingcategory',
    component: StichingCategory
  },
  {
    path: '/accountReport',
    name: 'accountReport',
    component: accountReport
  },

  {
    path: '/print',
    name: 'print',
    component: print
  },
  {
    path: '/addproduct',
    name: 'addproduct',
    component: AddProduct
  },


  {
    path: '/purchasess',
    name: 'purchasess',
    component: purchasessView
  },


  {
    path: '/listproduct',
    name: 'listproduct',
    component: ListProduct
  },
  {
    path: '/vendors',
    name: 'vendors',
    component: Vendors
  },
  {
    path: '/customer',
    name: 'customer',
    component: Customer
  },
  {
    path: '/saleview',
    name: 'saleview',
    component: SaleView
  },
  {
    path: '/salelist',
    name: 'salelist',
    component: SaleList
  },
  {
    path: '/purchaseview',
    name: 'purchaseview',
    component: PurchaseView
  },

  {
    path: '/purchaselist',
    name: 'purchaselist',
    component: PurchaseList
  },


  {
    path: '/delievryReport',
    name: 'delievryReport',
    component: delievryReport
  },

  {
    path: '/itemReport',
    name: 'itemReport',
    component: itemReport
  },

  {
    path: '/consumptionPrint',
    name: 'consumptionPrint',
    component: consumptionPrintView
  },

  {
    path: '/saleableproduct',
    name: 'saleableproduct',
    component: saleableproductView
  },

  {
    path: '/party',
    name: 'party',
    component: partyView
  },

  {
    path: '/saleconsumption',
    name: 'saleconsumption',
    component: saleconsumptionView
  },

  {
    path: '/saleconsumptionlist',
    name: 'saleconsumptionlist',
    component: saleconsumptionlistView
  },

  {
    path: '/saleconsumptionreport',
    name: 'saleconsumptionreport',
    component: saleconsumptionreportView
  },

  {
    path: '/saleleger',
    name: 'saleleger',
    component: salelegerView
  },

  {
    path: '/addexpenses',
    name: 'addexpenses',
    component: addexpensesView
  },

  {
    path: '/expensesreport',
    name: 'expensesreport',
    component: expensesreportView
  },

  {
    path: '/material',
    name: 'material',
    component: materialView
  },


  {
    path: '/materialtranscation',
    name: 'materialtranscation',
    component: materialtranscationView
  },

  {
    path: '/singleattendancereport',
    name: 'singleattendancereport',
    component: singleattendancereportView
  },

 {
    path: '/fuelstock',
    name: 'fuelstock',
    component: fuelstockView
  },

 {
    path: '/fuelparty',
    name: 'fuelparty',
    component: fuelpartyView
  },



  {
    path: '/group',
    name: 'group',
    component: groupView
  },


  {
    path: '/transcationlist',
    name: 'transcationlist',
    component: transcationlistView
  },

 {
    path: '/purchasetransaction',
    name: 'purchasetransaction',
    component: purchasetransactionView
  },

{
    path: '/fuelconsumption',
    name: 'fuelconsumption',
    component: fuelconsumptionView
  },

{
    path: '/fueltype',
    name: 'fueltype',
    component: fueltypeView
  },

{
    path: '/fuelconsumptionreport',
    name: 'fuelconsumptionreport',
    component: fuelconsumptionreportView
  },


{
    path: '/fueltransfer',
    name: 'fueltransfer',
    component: fueltrnasferView
  },

{
    path: '/singlefuelreport',
    name: 'singlefuelreport',
    component: singlefuelreportView
  },

{
    path: '/grapesView',
    name: 'grapesView',
    component: grapeslistView
  },

{
    path: '/purchaselistView',
    name: 'purchaselistView',
    component: purchaselistView
  },










  
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  //history: createWebHashHistory(),
  routes
})

export default router
